import { OpenDialogLegalNoticesComponent } from './../../../dialog/open-dialog-legal-notices/open-dialog-legal-notices.component';
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ClubDetails } from 'app/shared/models/class/club/club';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ClubService } from 'app/shared/services/club/club.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { MatDialog } from '@angular/material/dialog';

const reader = new FileReader();

@Component({
  selector: 'app-contact-address',
  templateUrl: './contact-address.component.html',
  styleUrls: ['./contact-address.component.scss']
})
export class ContactAddressComponent implements OnInit {
  clubSelected: ClubDetails;
  logoUpdate = false;
  isLoadingCGV = false;

  @Input() set club(value: ClubDetails) {
    this.clubSelected = value;
    if (value) {
      this.getImg(value?.logo);
    }
  }


  file: any;
  userConnected: any;
  clubCode: any;
  pdf: string;
  pdfTrust: any;
  updatePdf = false;
  logo: string;

  constructor(
    private uiService: UiService,
    private clubService: ClubService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private faIconService: FaiconService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.initComponent();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  uploadCGV(event): void {
    const file = event?.target.files[0];
    this.file = file;
    const { type } = file;

    if (['application/pdf'].includes(type)) {
      this.clubService.uploadCGV(this.clubCode, file).subscribe({
        next: () => {
          this.uiService.showSnackbar('CGV sauvegardées');
        }
      });
    } else {
      this.uiService.showSnackbar('Uniquement format pdf');
    }

  }

  uploadLogo(event): void {
    const file = event?.target.files[0];
    this.file = file;
    const { type } = file;

    if (['image/jpeg', 'image/png'].includes(type)) {
      this.clubService.uploadLogo(this.clubSelected.clubKey, file).subscribe({
        next: () => {
          reader.readAsDataURL(this.file);
          reader.onload = () => {
            this.logo = reader.result.toString();
            this.logoUpdate = true;
          };
          this.uiService.showSnackbar('Logo sauvegardé');
        }
      });
    } else {
      this.uiService.showSnackbar('Uniquement format jpeg ou png');
    }
  }

  updateCGV(): void {
    this.updatePdf = !this.updatePdf;
  }

  getImg(base64: any): any {
    this.logo = `data:image/png;base64,${base64}`;
  }

  private getCGV(): void {
    this.isLoadingCGV = true;
    this.clubService.getCGV(this.clubCode).subscribe({
      next: pdf => {
        this.pdf = pdf?.length ? `data:application/pdf;base64,${pdf}` : null;
        if (this.pdf) { this.pdfTrust = this.sanitizer.bypassSecurityTrustUrl(this.pdf); }
        this.isLoadingCGV = false;
      }
    });
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();

    this.clubCode = this.userConnected.role === 'admin' ?
      this.route.snapshot.queryParams.clubCode :
      this.userConnected.club_code;

    this.getCGV();
  }

  openDialogLegalNotices() {
    const dialogRef = this.dialog.open(OpenDialogLegalNoticesComponent, {
      data: { clubCode: this.clubCode},
      height: '85%',
      width: '80%',
    });

    dialogRef.afterClosed().subscribe({
      next: () => {

      }
    });
  }
}
